import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onActionFocusReceivable = useDataOnActionFocusReceivable(props, data)
  let onActionFocusPayment = useDataOnActionFocusPayment(props, data)

  return async function onSubmit({ value, change, args }) {
    switch (args?.type) {
      case 'FOCUS_RECEIVABLE': {
        return onActionFocusReceivable({ value, args })
      }
      case 'FOCUS_PAYMENT': {
        return onActionFocusPayment({ value, args })
      }
      default: {
      }
    }
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionFocusReceivable(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })
  return async function onAction({ args }) {
    change(next => {
      next.selected.ledger.view_mode = 'receivables'
      next.selected.ledger.receivables.focus_id = args.receivable_id
    })
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionFocusPayment(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })
  return async function onAction({ args }) {
    change(next => {
      next.selected.ledger.transactions.focus_id = args.payment_id
    })
  }
}
